import { AudioLines, Image, Link, Music, Play, Radio, Video, type LucideIcon } from "lucide-react";
import type { IconName, PlayerKind } from "./types";

const ICONS: Record<IconName, LucideIcon> = {
  play: Play, audioLines: AudioLines, radio: Radio, music: Music, image: Image, video: Video, link: Link,
};

/** The lucide glyph of an icon name (a kind's `icon`). */
export const iconFor = (name: IconName): LucideIcon => ICONS[name];

/** The glyph of a kind: wall rows, composer rows, dock art. */
export const kindIcon = (kind: PlayerKind): LucideIcon => ICONS[kind.icon];
